import React, { memo } from "react";
import * as PR from "../../../prime-modules/index";


const TopBundlesMonth = ({ monthGraph, loadingGraphs }) => {

  const sortByMonthVal = (a, b) => {
    return b.currentMonthVal - a.currentMonthVal
  };
  
  const filteredGraph = monthGraph?.filter(item => {
    return item.currentMonthVal 
  })    

  const sortedMonthGraph = (filteredGraph && filteredGraph.length > 0)
  ? filteredGraph.slice().sort(sortByMonthVal)
  : [{
      currentMonthVal: "0",
      description: "No bundles available",
      iso: "",
      percentageDiff: "0",
      previousMonthVal: "0"
    }];

  const renderPercentageDiff = (percentageDiff) => {
    if (percentageDiff === "+∞") {
      return "+∞";
    } else if (percentageDiff === "-∞") {
      return "-∞";
    } else if (percentageDiff != null) {
      return `${Math.abs(percentageDiff)}%`;
    } else {
      return "";
    }
  };

  return (
    <div className="card right-section">
      <div className="p-6 border-50 border-round-lg graph-block-bg">
        <div className="block-main popular-bundles">
          <div className="sticky-header">
            <div className="flex align-items-center justify-content-between">
              <h2>Popular Bundles</h2>
            </div>
          </div>
          <div className="mt-3">
            {loadingGraphs?.popularBundles ? (
              <div style={{ height: "250px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <PR.ProgressSpinner />
              </div>
            ) : sortedMonthGraph.length > 0 ? (
            <>
            {sortedMonthGraph.map((item, index) => (
              <div key={index} className="mb-5 tab-number">
                <div className="flex align-items-center justify-content-between">
                  <div className="left">
                    <span style={{ fontWeight: "bold" }}>{`${item.iso}`}</span>
                    <span className="description">{`${item.description}`}</span>
                  </div>
                  <div className="right">
                    <ul className="flex align-items-center gap-3">
                      <li>
                        <span>
                             {item.currentMonthVal}
                        </span>
                      </li>
                      <li>
                      <div className="percentage">
                          {item.percentageDiff && (
                            <span
                              className={
                                "percentage " +
                                (item.percentageDiff === "+∞" || item.percentageDiff > 0
                                  ? "up"
                                  : item.percentageDiff === "-∞" || item.percentageDiff < 0
                                  ? "down"
                                  : "normal")
                              }
                            >
                              {(item.percentageDiff === "+∞" || item.percentageDiff > 0) && (
                                <i className="pi pi-arrow-up-right" />
                              )}
                              {(item.percentageDiff === "-∞" || item.percentageDiff < 0) && (
                                <i className="pi pi-arrow-down-left" />
                              )}
                              {renderPercentageDiff(item.percentageDiff)}
                            </span>
                          )}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="progressBar">
                  <div
                    className="progress-percentage"
                    style={{
                      width: `${item.currentMonthVal}px`,
                      height: "8px",
                      backgroundColor: "#f73759",
                    }}
                  ></div>
                </div>
              </div>
            ))}
            </>
            ) : (
            <div>No data available</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default memo(TopBundlesMonth);
